import createList from '../../with-list';

import endpoints from '../../../../config/endpoints';

const namespace = 'blogArticleList';

const { actions, selectors, reducers } = createList({
	namespace,
	url: endpoints.BLOG.ARTICLES,
	perPage: 50
});

export { namespace, actions, selectors, reducers as default };


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article/list/index.js